import {useEffect, useState} from "react";
import { connect } from "react-redux";
import {useIsMounted} from "../../../misc/helperHooks";
import {setLookDemoPointsClicked} from "../../../actions/lookFunctions";
// import {LOOK_INTRO_STEPS, LOOK_OVERLAYS} from "../core/constants";

const WithDemoShow = (props) => {

  const {lookOpened, contextMenu, introStep, lookOverlayOpened, lookPageOpened, visualizersLoaded, children, canvasScale,
    lookDemoPointsClicked, setLookDemoPointsClicked, isMobile} = props;
  const [showPoints, setShowPoints] = useState(true);
  const isMounted = useIsMounted();

  let timeoutId = 0;

  useEffect(() => {
    let show
    if (lookDemoPointsClicked) {
      show = !(lookOpened || contextMenu.opened || canvasScale > 1);
      setShowPoints(show);
    }
    if (show && lookDemoPointsClicked) {
      window.clearTimeout(timeoutId);
      window.setTimeout(() => {
        if (isMounted()) {
          setShowPoints(false);
        }
      }, isMobile ? 1500 : 3000)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lookOpened, contextMenu.opened, canvasScale, lookDemoPointsClicked])

  useEffect(() => {
    if (isMobile) {
      window.setTimeout(() => {
        setLookDemoPointsClicked(true)
      }, 10000) // after the tool is loaded
    }
    return () => {
      window.clearTimeout(timeoutId)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (!lookDemoPointsClicked && (canvasScale > 1)) {
      setLookDemoPointsClicked(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [canvasScale])

  // if ((lookOverlayOpened !== LOOK_OVERLAYS.intro || introStep !== LOOK_INTRO_STEPS.wallsAndFloor) || lookPageOpened || !visualizersLoaded.length) {
  if (introStep || lookOverlayOpened || lookPageOpened || !visualizersLoaded.length) {
    return null
  }

  return children(showPoints)
};

const mapStateToProps = (store) => {
  const {contextMenu, lookOpened, introStep, lookOverlayOpened, lookPageOpened, lookDemoPointsClicked} = store.lookState;
  const {canvasDimensions, activePreset, canvasCount, canvasScale} = store.bathroomVisualizerState;
  const {windowWidth, windowHeight, visualizersLoaded, isMobile} = store.serverState;
  return {
    introStep,
    lookOverlayOpened,
    contextMenu,
    lookOpened,
    canvasDimensions,
    windowWidth,
    windowHeight,
    visualizersLoaded,
    activePreset,
    canvasCount,
    lookPageOpened,
    canvasScale,
    lookDemoPointsClicked,
    isMobile,
  };
};

const mapDispatchToProps = {
  setLookDemoPointsClicked
};

export default connect(mapStateToProps, mapDispatchToProps)(WithDemoShow)
